export default "__VITE_ASSET__91121471__"